import { render, staticRenderFns } from "./ListAllDocumentTypes.vue?vue&type=template&id=511e5752&"
import script from "./ListAllDocumentTypes.vue?vue&type=script&lang=js&"
export * from "./ListAllDocumentTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('511e5752')) {
      api.createRecord('511e5752', component.options)
    } else {
      api.reload('511e5752', component.options)
    }
    module.hot.accept("./ListAllDocumentTypes.vue?vue&type=template&id=511e5752&", function () {
      api.rerender('511e5752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/lists/components/ListAllDocumentTypes.vue"
export default component.exports